import script from "./ProjectListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectListItem.vue?vue&type=style&index=0&id=12c2ef68&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c2ef68"]])

export default __exports__